jQuery(document).ready(function() {

    var legalForm = document.querySelector('.legal-fields-form');
    var technicalForm = document.querySelector('.technical-fields-form');

    if ( !legalForm && !technicalForm ) { return };

    var getSelectLegal = document.getElementById('legal_fields');
    var getSelectTechnical = document.getElementById('technical_fields');
    var getSortByName = document.querySelector('#sort-by-name');
    var getSortByExperience = document.querySelector('#sort-by-experience');

    function setActiveButton( sortValue ) {
        if ( typeof sortValue === 'undefined' || sortValue !== 'name' ) {
            getSortByExperience.disabled = true;
            getSortByName.disabled = false;
        } else {
            getSortByExperience.disabled = false;
            getSortByName.disabled = true;
        }
    }

    // Returns all professionals on page load; Returns filtered professionals when page loads with GET parameters in place
    function runDatabaseQueryOnReady() {

        var selectedOptionLegal = getSelectLegal.value;
        var selectedOptionTechnical = getSelectTechnical.value;
        var url = new URLSearchParams(window.location.search);
        var sortValue = url.get('sort_by');

        setActiveButton( sortValue );

        $.ajax({
            url: ajaxurl,
            type: 'GET',
            data: {
                'legal_specialty': selectedOptionLegal,
                'technical_specialty': selectedOptionTechnical,
                'sort_by': sortValue,
                action: 'filter_by_specialty'
            },
            success: function(response) {
                var ajaxDisplay = document.querySelector('.card-container');
                ajaxDisplay.innerHTML = response;
            },
            error: function() {
                console.log('AJAX Error - Failure at send.');
            }
        });
    }

    runDatabaseQueryOnReady();

    // Listen for legal fields select option to change and set GET parameters
    legalForm.onchange = function(ev) {

        var selectedOptionLegal = getSelectLegal.value;
        var selectedOptionTechnical = getSelectTechnical.value;
        var url = new URLSearchParams(window.location.search);

        url.set('legal_specialty', selectedOptionLegal);

        window.history.pushState('', '', window.location.pathname + '?' + url);

        var sortValue = url.get('sort_by');

        setActiveButton( sortValue );

        function runDatabaseQuery() {

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    'legal_specialty': selectedOptionLegal,
                    'technical_specialty': selectedOptionTechnical,
                    'sort_by': sortValue,
                    action: 'filter_by_specialty'
                },
                success: function(response) {
                    var ajaxDisplay = document.querySelector('.card-container');
                    ajaxDisplay.innerHTML = response;
                },
                error: function() {
                    console.log('AJAX Error - Failure at send.');
                }
            });
        }

        runDatabaseQuery();
    }

    // Listen for technical fields select option to change and set GET parameters
    technicalForm.onchange = function(ev) {

        var selectedOptionLegal = getSelectLegal.value;
        var selectedOptionTechnical = getSelectTechnical.value;
        var url = new URLSearchParams(window.location.search);

        url.set('technical_specialty', selectedOptionTechnical);

        window.history.pushState('', '', window.location.pathname + '?' + url);

        var sortValue = url.get('sort_by');

        setActiveButton( sortValue );

        function runDatabaseQuery() {

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    'legal_specialty': selectedOptionLegal,
                    'technical_specialty': selectedOptionTechnical,
                    'sort_by': sortValue,
                    action: 'filter_by_specialty'
                },
                success: function(response) {
                    var ajaxDisplay = document.querySelector('.card-container');
                    ajaxDisplay.innerHTML = response;
                },
                error: function() {
                    console.log('AJAX Error - Failure at send.');
                }
            });
        }

        runDatabaseQuery();
    }

    // Listen for click and set GET parameters
    getSortByExperience.onclick = function(ev) {

        var selectedOptionLegal = getSelectLegal.value;
        var selectedOptionTechnical = getSelectTechnical.value;
        var sortValue = getSortByExperience.innerHTML.toLowerCase();
        var url = new URLSearchParams(window.location.search);

        url.set('sort_by', sortValue);

        window.history.pushState('', '', window.location.pathname + '?' + url);

        setActiveButton(sortValue);

        function runDatabaseQuery() {

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    'legal_specialty': selectedOptionLegal,
                    'technical_specialty': selectedOptionTechnical,
                    'sort_by': sortValue,
                    action: 'filter_by_specialty'
                },
                success: function(response) {
                    var ajaxDisplay = document.querySelector('.card-container');
                    ajaxDisplay.innerHTML = response;
                },
                error: function() {
                    console.log('AJAX Error - Failure at send.');
                }
            });
        }

        runDatabaseQuery();
    }

    // Listen for click and set GET parameters
    getSortByName.onclick = function(ev) {

        var selectedOptionLegal = getSelectLegal.value;
        var selectedOptionTechnical = getSelectTechnical.value;
        var sortValue = getSortByName.innerHTML.toLowerCase();
        var url = new URLSearchParams(window.location.search);

        url.set('sort_by', sortValue);

        window.history.pushState('', '', window.location.pathname + '?' + url);

        setActiveButton(sortValue);

        function runDatabaseQuery() {

            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    'legal_specialty': selectedOptionLegal,
                    'technical_specialty': selectedOptionTechnical,
                    'sort_by': sortValue,
                    action: 'filter_by_specialty'
                },
                success: function(response) {
                    var ajaxDisplay = document.querySelector('.card-container');
                    ajaxDisplay.innerHTML = response;
                },
                error: function() {
                    console.log('AJAX Error - Failure at send.');
                }
            });
        }

        runDatabaseQuery();
    }

    // Reset all fields and reset URL to remove GET parameters
    var resetButton = document.querySelector('.reset-button');

    resetButton.onclick = function (ev) {

        var elements = document.getElementsByTagName('select');

        for (var i = 0; i < elements.length; i++) {
            elements[i].selectedIndex = 0;
        }

        window.history.pushState('', '', window.location.pathname);

        setActiveButton(null);

        function runDatabaseQueryOnReset() {

                $.ajax({
                    url: ajaxurl,
                    type: 'GET',
                    data: {
                        action: 'filter_by_specialty'
                    },
                    success: function(response) {
                        var ajaxDisplay = document.querySelector('.card-container');
                        ajaxDisplay.innerHTML = response;
                    },
                    error: function() {
                        console.log('AJAX Error - Failure at send.');
                    }
                });
            }

        runDatabaseQueryOnReset();
    }

});